import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-by': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M314.9 194.4V295.8H286.6V416.3H209.5V295.9H181.2V194.4C181.2 190 182.8 186.2 185.8 183.1 188.9 180 192.7 178.4 197.1 178.4H299C303.1 178.4 306.8 180 310.1 183.1 313.2 186.3 314.9 190 314.9 194.4zM213.4 130.7C213.4 107.4 224.9 95.7 247.9 95.7S282.4 107.4 282.4 130.7C282.4 153.7 270.9 165.2 247.9 165.2S213.4 153.7 213.4 130.7zM247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-by.js
// module id = sSx1
// module chunks = 144